import { createAsyncTypes } from 'utils/ActionCreator'

export const MODAL_OPEN = 'ResolutionCenter/ReportCommunicationModal/OPEN'
export const MODAL_CLOSE = 'ResolutionCenter/ReportCommunicationModal/CLOSE'
export const COMMENT_AND_TAGS_UPDATE_ASYNC = createAsyncTypes(
  'COMMENT_AND_TAGS_UPDATE',
  'ResolutionCenter/ReportCommunicationModal'
)
